/* 李典（字曼成） */
import { SG, K, gd, along, spMul } from '../../core/kit.ts';
import { defineHero, hook, S, D } from '../define.ts';

export default defineHero({
  id: 'lidian', name: '李典', sub: '字曼成', faction: 'wei', role: '坦克', weapon: 'sword',
  look: { shield: true, beard: 'goatee', bulk: 1.1, fx: '#e9d8a6', c: { plume: '#c9a24e', armor: '#4a5a7a' } },
  skills: [
    ['合肥陣', 'roar', '舉盾撞擊前方扇形，{70/110/150/190} 傷害並緩速 40% 2 秒。', { x: { k: 'bash', dmg: [70, 110, 150, 190], r: 180 }, aim: D(180, 90), cd: 9, mp: [60, 70, 80, 90], el: 'earth' }],
    ['博望識伏', 'shield', '周圍 500 內的友將得到技能護盾 4 秒（擋下下一個敵方技能），並看穿 {600/700/800/900} 內隱身、躲在草叢或迷霧裡的敵人 4 秒。', { x: { k: 'foresight', r: 500, sight: [600, 700, 800, 900], dur: 4 }, aim: S(500), cd: [24, 22, 20, 18], mp: 90, el: 'holy' }],
    ['儒將', 'passive', '附近友軍防禦 +{2/3/4/5}。', { pv: { aura: { r: 600, armor: [2, 3, 4, 5] } } }],
    ['舉宗遷鄴', 'command', '召喚一排宗族兵牆（寬 {500/600/700}），朝游標方向推進 500 距離，沿途把敵人一路推走並造成 {150/225/300} 傷害，之後原地站成一道牆 3 秒擋住去路。', { x: { k: 'clanwall', w: [500, 600, 700], dmg: [150, 225, 300], push: 500, hold: 3 }, aim: D(500, 60), cd: [110, 95, 80], mp: [150, 175, 200], el: 'earth', shout: '宗族部曲，隨我遷鄴！' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    bash(u, a, X) {
      const sp = spMul(u);
      this.cone(u, a.dir, X.r, 0.5).forEach((t) => { this.damage(u, t, X.dmg * sp * (t.structure ? 0.5 : 1), { magic: true, spell: true, stagger: 0.35, knock: 20 }); this.applyCC(u, t, { slow: [0.4, 2] }); });
      this.fx({ k: 'slam', x: u.x + a.dir[0] * 60, y: u.y + a.dir[1] * 60 * K, col: '#e9d8a6' });
    },
    foresight(u, a, X) {
      this.heroes(u.team).forEach((h) => { if (h.alive && gd(u.x, u.y, h.x, h.y) <= X.r) { h.sshieldT = this.t + X.dur; this.fx({ k: 'heal', x: h.x, y: h.y, col: '#ffe9a8' }); } });
      this.units.forEach((t) => { if (t.alive && t.team === 1 - u.team && !t.structure && gd(u.x, u.y, t.x, t.y) <= X.sight) this.expose(t, u.team, X.dur); });
    },
    clanwall(u, a, X) {
      const d = a.dir, tx = -d[1], ty = d[0];
      const c0 = along(u.x, u.y, d, 60);
      u.clan = { c0, d, tx, ty, w: X.w, push: X.push, t0: this.t, dur: 0.9, dmg: X.dmg * spMul(u), hold: X.hold, hit: {} };
    },
  },
  methods: {
    // 兵牆推進：沿途把敵人推到牆前
    clanTick(u) {
      const c = u.clan, k = Math.min(1, (this.t - c.t0) / c.dur), dist = c.push * k;
      const cx = c.c0[0] + c.d[0] * dist, cy = c.c0[1] + c.d[1] * dist * K;
      c.cx = cx; c.cy = cy;
      for (const t of this.units) {
        if (!this.hostile(u, t) || t.structure || t.kind === 'boss' || t.kind === 'cart') continue;
        const rx = t.x - cx, ry = (t.y - cy) / K, along1 = rx * c.tx + ry * c.ty, ahead = rx * c.d[0] + ry * c.d[1];
        if (Math.abs(along1) > c.w / 2 || ahead < -40 || ahead > 40) continue;
        if (!c.hit[t.id]) { c.hit[t.id] = 1; this.damage(u, t, c.dmg, { magic: true, spell: true, stagger: 0.4 }); }
        const nx = cx + c.d[0] * 42 + c.tx * along1, ny = cy + (c.d[1] * 42 + c.ty * along1) * K;
        if (SG.walkBase(nx, ny)) { t.x = nx; t.y = ny; }
      }
      if (k >= 1) {
        const h = c.w / 2;
        this.addWall([cx - c.tx * h, cy - c.ty * h * K, cx + c.tx * h, cy + c.ty * h * K], 40, c.hold, u.team, 'clan');
        u.clan = null;
      }
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 博望識伏：技能護盾擋下下一個敵方技能（同一招接著的控制也擋）
    hook('damage.before', 50, function (c) {
      const t = c.t, own0 = c.own, o = c.o;
      if (o && (o.spell || o.sk) && t.sshieldT > this.t && own0.team !== t.team) {
        t.sshieldT = 0; t.sshieldGrace = this.t + 0.15;
        this.fx({ k: 'heal', x: t.x, y: t.y, col: '#ffe9a8' });
        if (t.human || own0.human) this.dmgEvents.push({ x: t.x, y: t.y - 60, text: '識伏', team: t.team, src: own0.id, tgt: t.id });
        return true;
      }
    }),
    hook('cc.block', 20, function (c) { if (c.cc && c.t.sshieldGrace > this.t && c.own && c.own.team !== c.t.team) return true; }),
    // 舉宗遷鄴：兵牆推進
    hook('tick', 120, function (u, dt) { if (u.clan) this.clanTick(u); }),
  ],
  // 電腦什麼時候放這招
  ai: {
    foresight: ({ w, u, t, d, hero, hpR, foeHeroes }) => w.enemiesNear(u, u.x, u.y, 700).some((e) => e.kind === 'hero'),
    clanwall: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 450,
  },
});
